import { CapoPlugin } from "C:/vnimpex/tcms-framework-test-3001/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];